import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CORE_CONFIG_TOKEN } from '@ndk/ng-core/component/core.config';
import { Observable, of as observableOf, Subject } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';

import { AuthTokenService } from '@core/authentication/auth-token.service';
import { RoleTypes } from '@core/authentication/shared/role-types.enum';
import { ICoreConfigInternal } from '@core/core.config.model';
import { UserService } from '@features/user/shared/user.service';

import { QuotaBehaviorTypes } from './quota-behavior-types.enum';
import { QuotaObjectTypes } from './quota-object-types.enum';

@Injectable()
export class QuotaParameterService {
    public refreshShowQuotasStatus$: Subject<{ showQuotas: boolean }> = new Subject<{ showQuotas: boolean }>();

    private apiUrl: string;

    constructor(
        @Inject(CORE_CONFIG_TOKEN) config: ICoreConfigInternal,
        private http: HttpClient,
        private authTokenService: AuthTokenService,
        private userService: UserService,
    ) {
        this.apiUrl = `${ config.apiEndpoint }api/quota-parameters`;
    }

    public getQuotasReportConfig(): Observable<any> {
        return this.http.get(`${ this.apiUrl }/quotas-report`);
    }

    public getQuotaType(): Observable<QuotaObjectTypes> {
        return this.http.get<QuotaObjectTypes>(`${ this.apiUrl }/quota-type`);
    }

    public showQuotas(): Observable<boolean> {
        return this.getQuotasReportConfig()
            .pipe(
                map((response: any) => response.quotaState !== QuotaBehaviorTypes.Disabled),
                mergeMap((isQuotasEnabled: boolean) => {
                    if (!isQuotasEnabled) {
                        return observableOf(false);
                    }

                    return this.getQuotaType()
                        .pipe(mergeMap((quotaType: QuotaObjectTypes) => {
                            // tslint:disable-next-line:no-bitwise
                            const isAdmin: boolean = !!(this.authTokenService.role & RoleTypes.Administrators);

                            if (quotaType === QuotaObjectTypes.Users && !isAdmin) {
                                return this.userService.isManager();
                            }

                            return observableOf(isAdmin);
                        }));
                }),
            );
    }

    public showQuotasForPartner(): Observable<boolean> {
        return this.getQuotasReportConfig()
            .pipe(
                map((response: any) => response.quotaState !== QuotaBehaviorTypes.Disabled),
                mergeMap((isQuotasEnabled: boolean) => {
                    if (!isQuotasEnabled) {

                        return observableOf(false);
                    }

                    return observableOf(true);
                }),
            );
    }
}
